import React, {useContext, useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import {StateContext} from '../../../store';
import Box from '@mui/material/Box';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import Typography from '@mui/material/Typography';
import {Card, Grid} from '@mui/material';
import {GlassMagnifier} from 'react-image-magnifiers';
import {Images} from '../../../common/Assets/Images';
import Moment from 'react-moment';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import {conservationAction} from '../../../services/ConservationServices';
import ActivityLogsConservation from './ActivityLogsConservation';
import ConservationsDetailActions from './ConservationsDetailActions';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function ConservationDetail() {
  const navigate = useNavigate();
  const {commonUpdate} = useContext(StateContext);
  const [item, setItem] = useState({});
  const params = useParams();
  const id = params.id;
  const [changeIndex, setChangeIndex] = useState(0);
  const [changeAfterIndex, setChangeAfterIndex] = useState(0);
  const dimensions = item?.catalogue?.dimensions || [];
  const [openLog, setOpenLog] = useState(false);

  useEffect(() => {
    getItemDetail();
  }, [commonUpdate]);

  const getItemDetail = () => {
    conservationAction('get', id).then(res => {
      setItem(res?.data);
    })
  }

  const handleSelectedIndex = (index) => {
    setChangeIndex(index);
  }

  const handleSelectedAfterIndex = (index) => {
    setChangeAfterIndex(index);
  }

  const formatDimensions = (dimensions) => {
    const width = dimensions?.find(dim => dim?.name === 'Width')?.value || 'N/A';
    const height = dimensions?.find(dim => dim?.name === 'Height')?.value || 'N/A';
    const length = dimensions?.find(dim => dim?.name === 'Length')?.value || 'N/A';

    return `${length}cm x ${width}cm x ${height}cm`;
  };


  const formatWeight = (dimensions) => {
    const weight = dimensions?.find(dim => dim?.name === 'Weight')?.value || 'N/A';

    return `${weight} kg`;
  };

  const toggleLog = () => {
    setOpenLog(!openLog);
  }

  const handleLogClose = () => {
    setOpenLog(false);
  }

  const handleEdit = () => {
    navigate(`/management/conservators/edit/?id=${id}`);
  }

  const asText = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || value?.description || String(value?.id || '-');
    }
    const str = String(value);
    return str?.trim?.() ? str : '-';
  };

  return (
    <PageWrapper>
    <Box sx={{position: 'relative'}}>
      <Box className={'space-between'} sx={{marginTop: 5}}>
        <Box onClick={() => navigate(-1)}
             className={'flex-cx-center hand-cursor'}>
          <ArrowBackIosRoundedIcon sx={{color: '#757575'}}/>
          <Typography variant={'h5'} sx={{color: '#757575'}}>{item?.catalogue?.object_name}</Typography> &nbsp;
          (<Typography sx={{color: '#757575'}}>{formatDimensions(dimensions)}, {formatWeight(dimensions)}</Typography>)
        </Box>
        <ConservationsDetailActions item={item} handleEdit={handleEdit} conservationId={id}/>
      </Box>
      <Box className={'header-divider'}/>
      <Grid container spacing={2}>
        <Grid item sm={5} xs={12}>
          <Box>
            <Card className={'box-shadow position-relative'} sx={{width: '100%'}}>
              <Box className={'position-absolute'} sx={{p: 1, backgroundColor: '#40B259', zIndex: 99}}>
                <Typography sx={{left: 0, top: 0, color: '#fff'}}>Upload Photo Before</Typography>
              </Box>
              <Box sx={{height: {sm: 300, xs: '100%'}, pl: {sm: 14, xs: 0}, pr: {sm: 14, xs: 0}}}>
                <GlassMagnifier
                  imageSrc={item?.before_photos?.[changeIndex]?.file || Images.logoWhite}
                  imageAlt="Item Image"
                  largeImageSrc={item?.before_photos?.[changeIndex]?.file || Images.logoWhite}
                  largeImageAlt="Zoomed Image"
                  magnifierSize="50%"
                  square
                />
              </Box>
            </Card>
            <Grid container spacing={1} sx={{mt: 0.5}}>
              {item?.before_photos?.length > 0 && item?.before_photos?.map((attachment, index) => (
                <Grid item sm={2.4} xs={2.4} key={index}>
                  <Card sx={{height: 100}}>
                    <img onClick={() => handleSelectedIndex(index)} draggable={false} width={'100%'} height={'100%'}
                         style={{borderRadius: 5, objectFit: 'contain'}}
                         src={attachment?.file || Images?.logoWhite}
                         alt="item_image"/>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
          {item?.after_photos?.length > 0 &&
          <Box sx={{mt: 3}}>
            <Card className={'box-shadow position-relative'} sx={{width: '100%'}}>
              <Box className={'position-absolute'} sx={{p: 1, backgroundColor: '#40B259', zIndex: 99}}>
                <Typography sx={{left: 0, top: 0, color: '#fff'}}>Upload Photo After</Typography>
              </Box>
              <Box sx={{height: {sm: 300, xs: '100%'}, pl: {sm: 14, xs: 0}, pr: {sm: 14, xs: 0}}}>
                <GlassMagnifier
                  imageSrc={item?.after_photos?.[changeAfterIndex]?.file || Images.logoWhite}
                  imageAlt="Item Image"
                  largeImageSrc={item?.after_photos?.[changeAfterIndex]?.file || Images.logoWhite}
                  largeImageAlt="Zoomed Image"
                  magnifierSize="40%"
                  square
                />
              </Box>
            </Card>
            <Grid container spacing={1} sx={{mt: 0.5}}>
              {item?.after_photos?.map((attachment, index) => (
                <Grid item sm={2.4} xs={2.4} key={index}>
                  <Card sx={{height: 100}}>
                    <img onClick={() => handleSelectedAfterIndex(index)} draggable={false} width={'100%'}
                         height={'100%'}
                         style={{borderRadius: 5, objectFit: 'contain'}}
                         src={attachment?.file || Images?.logoWhite}
                         alt="item_image"/>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </Box>
          }
        </Grid>
        <Grid item sm={7} xs={12}>
          <Card className={'box-shadow'}>
            <Box sx={{p: 2}}>
              <Typography className={'font20 text-500 dark-color'}>Conservation Data</Typography>
            </Box>
            <Box className={'common-divider'}/>
            <Box sx={{p: 2}}>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>ACCESSION NO: </Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.accession_no)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>CLASSIFICATION:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.object_group || item?.catalogue?.classification)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>OBJECT NAME:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.catalogue?.object_name}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>MATERIALS:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.material)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>DIMENSIONS:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography
                    className={'font-15'}>{formatDimensions(dimensions)}, {formatWeight(dimensions)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>INCOMING DATE:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}><Moment format={'ll'}>{item?.incoming_date}</Moment></Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>CONDITION ASSESSMENT::</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.condition_assessment}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>TREATMENT PLAN:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.treatment_plan}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>COMPLETION DATE:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}><Moment format={'ll'}>{item?.completion_date}</Moment></Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>CONDITION ASSESSMENT:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.condition_assessment_after || '-'}</Typography>
                </Grid>
              </Grid>
            </Box>
          </Card>
          <Card className={'box-shadow'} sx={{p: 2, mt: 1}}>
            <Typography className={'dark-color font-15 text-500'}>DESCRIPTION</Typography>
            <Typography className={'font-14'}>{asText(item?.catalogue?.description)}</Typography>
          </Card>
        </Grid>
      </Grid>
      <Box sx={{position: 'fixed', right: 0, bottom: '10%'}}>
        <Card onClick={toggleLog} className={'box-shadow'}
              sx={{
                pr: 2.5,
                pl: 2,
                pt: 1,
                pb: 1.5,
                zIndex: 20000,
                backgroundColor: "#616B88",
                borderTopLeftRadius: 50,
                borderBottomLeftRadius: 50,
                cursor: "pointer",
              }}>
          <ArrowBackIosNewRoundedIcon fontSize={'small'} sx={{color: '#fff', marginTop: 1}}/>
        </Card>
      </Box>
      <ActivityLogsConservation openLog={openLog} handleLogClose={handleLogClose} conservationId={id}/>
    </Box>
    </PageWrapper>
  );
}